if (!customElements.get('flip-basic-performance')) {
  customElements.define(
    'flip-basic-performance',
    class FlipBasicPerformance extends HTMLElement {
      constructor() {
        super();

        this.tabLinks = this.querySelectorAll('.tab-links li');
        this.tabPanels = this.querySelectorAll('.tab-content .tab');

        this.tabLinks.forEach((link) => link.addEventListener('click', this.onTabClick.bind(this)));

        // pc轮播图
        this.carousel = this.querySelector('.flip-basic-performance-carousel');
        // mobile轮播图
        this.mobileCarousel = this.querySelector('.flip-basic-performance-carousel-mobile');

        this.carousel.addEventListener('change', this.onCarouselChange.bind(this));
        this.mobileCarousel.addEventListener('change', this.onCarouselChange.bind(this));

        // 左箭头
        this.navigationLeft = this.querySelector('.tab-navigation-links .tab-navigation-left');
        // 右箭头
        this.navigationRight = this.querySelector('.tab-navigation-links .tab-navigation-right');

        this.navigationLeft.addEventListener('click', this.prev.bind(this));
        this.navigationRight.addEventListener('click', this.next.bind(this));

        // this.linearGradient(this.carousel.currentIndex);
      }

      onTabClick(event) {
        event.preventDefault();

        const clickedLink = event.currentTarget;
        this.tabsChange(clickedLink);

        // 轮播图跳转
        const index = Number(clickedLink.getAttribute('data-tab-index'));

        this.carousel.goto(index);
        this.mobileCarousel.goto(index);
      }

      onCarouselChange(event) {
        const { currentIndex } = event.detail || {};

        const clickedLink = this.querySelector(`[data-tab-index="${currentIndex}"]`);
        this.tabsChange(clickedLink);
      }

      tabsChange(clickedLink) {
        // 去掉 active
        this.tabLinks.forEach((link) => link.classList.remove('active'));
        this.tabPanels.forEach((panel) => {
          panel.classList.remove('active');
          panel.style.display = 'none';
        });

        clickedLink.classList.add('active');

        // 内容
        const targetPanel = this.querySelector(`[data-panel-index="${clickedLink.getAttribute('data-tab-index')}"]`);
        if (targetPanel) {
          targetPanel.classList.add('active');
          targetPanel.style.display = 'block';
        }
      }

      // 切换到上一张轮播图
      prev() {
        this.carousel.prev();
        this.mobileCarousel.prev();
      }

      // 切换到下一张轮播图
      next() {
        this.carousel.next();
        this.mobileCarousel.next();
      }

      linearGradient(currentIndex) {
        // 运营说渐变不要了 先注释掉
        // this.imageContainer = this.carousel.querySelectorAll('.image-container');
        // const length = this.carousel.querySelector('.image-container').getAttribute('data-blocks-length');
        // this.imageContainer.forEach((container) => {
        //   container.classList.remove('left-linear-gradient');
        //   container.classList.remove('right-linear-gradient');
        // });
        // const currentImageContainers = this.carousel.querySelectorAll(`[data-image-container-index="${currentIndex}"]`);
        // currentImageContainers.forEach((container) => {
        //   container.classList.add('left-linear-gradient');
        // });
        // let indexAddtwo = currentIndex + 2;
        // if (indexAddtwo >= length) {
        //   indexAddtwo = indexAddtwo - length;
        // }
        // const imageContainersAddtwo = this.carousel.querySelectorAll(`[data-image-container-index="${indexAddtwo}"]`);
        // imageContainersAddtwo.forEach((container) => {
        //   container.classList.add('right-linear-gradient');
        // });
      }
    }
  );
}
